module.exports = "<button class=\"close\"\n        data-dismiss=\"modal\"\n        data-autotest-button=\"close\"\n        (click)=\"onBtnClick()\"\n        type=\"button\"\n>&times;</button>\n"


//////////////////
// WEBPACK FOOTER
// ./shared/components/common/buttons/close-btn/close-btn.html
// module id = ./shared/components/common/buttons/close-btn/close-btn.html
// module chunks = 0